import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import React, { ChangeEvent, KeyboardEvent, MouseEvent, ReactElement, useEffect, useState } from "react";
import { RegistrationClassTabProps } from "../registration-class";
import { useLocation, useParams } from "react-router-dom";
import {
  addStudentEnrolledClass,
  deleteStudentEnrolledClass,
  getListStudentCourse,
  getSampleTemplateUsersExcel
} from "../../../../service/course-construct";
import TableData from "../../../../components/table-data/TableData";
import {
  Button,
  Flex,
  Form,
  FormInstance,
  message,
  Modal,
  Progress,
  Space,
  TableColumnsType,
  TableProps,
  Typography,
  UploadFile
} from "antd";
import { CloseOutlined, DeleteFilled, DeleteOutlined, FileExcelOutlined, SaveOutlined } from "@ant-design/icons";
import { formatDateV2 } from "../../../../utils/converDate";
import { Page500 } from "../../../index";
import FilterTable from "./filter-table";
import DrawerCustom from "../../../../components/drawer/Drawer";
import CreateStudent from "./create-student";
import FormTable from "./form-table";
import { get } from "lodash";
import ModalUploadFileExcel from "../../../../components/modal/modal-upload-file-excel";
import { ExcelFileIcon } from "../../../../components/icons/svg";
import { UploadListType, UploadProps } from "antd/es/upload/interface";
import { BASE_URL_V2 } from "../../../../config/api/configApiv2";
import { useAuthStore } from "../../../../stores/stores";
import { findSchoolForStudent } from "../../../../service/notifications";
import { getPopularTopics } from "../../../../service/courses";
import { saveAs } from "file-saver";
import { FileType } from "../../../../utils/uploadImage";
import { convertErrors } from "../../../../utils/arrays";

function ListStudentTab(props: RegistrationClassTabProps) {
  const { t } = useTranslation();
  const { dataDetail } = props
  const [form] = Form.useForm()
  const { confirm } = Modal;
  const location = useLocation();
  const { classId, enrolledDate, id } = useParams();
  const { accessToken } = useAuthStore()
  const [loadingContent, setLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);
  const [dataStudents, setDataStudents] = useState([])
  const [searchValue, setSearchValue] = useState<string>('')
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [checkUploadFile, setCheckUploadFile] = useState<boolean>(false)
  const [percentUpload, setPercentUpload] = useState(0);

  const [isOpenDrawer, setIsOpenDrawer] = useState<boolean>(false);
  const [isOpenedImport, setIsOpenedImport] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [isTitleEdit, setIsTitleEdit] = useState<boolean>(false)
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [fileList, setFileList] = useState<FileType[]>([]);
  const [deletedStudents, setDeletedStudents] = useState<number[]>([]);

  const [isDirty, setIsDirty] = useState<boolean>(false)

  const [dataOptions, setDataOptions] = useState({
    dataUniversity: [],
    dataIndustry: [],
  });

  const [filterData, setFilterData] = useState<any>({
    enrolledClassId: null,
    enrolledDateStart: null,
    enrolledDateDate: null,
  });


  const getOptions = async () => {
    const response = await Promise.all([findSchoolForStudent(), getPopularTopics({
      page: 1,
      size: 1000,
      keyword: ""
    })])

    setDataOptions({
      ...dataOptions,
      dataUniversity: response[0].data.data,
      dataIndustry: response[1].data.content
    })
  }


  useEffect(() => {
    if (props.currentTab === '3') {
      getStudents()
      getOptions()
    }
  }, [props.currentTab, id, pageNumber, pageSize]);

  const getStudents = async () => {
    setLoadingContent(true)
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      enrollClassId: classId,
    }

    try {
      const response = await getListStudentCourse(dataReq)
      const { data, status } = response
      if (status === 200) {
        setDataStudents(data.content);
        setTotalRecords(data.totalElements)
        setHasError(false);
        setLoadingContent(false)
      }

    } catch (error) {
      setHasError(true)
      console.error(error);
    }
  };

  const createNewStudentEnrollClass = async (dataReq: any) => {
    try {
      const response = await addStudentEnrolledClass(dataReq)
      const { success } = response.data
      if (success) {
        message.success(t('Thêm học viên thành công', 'Thêm học viên thành công'))
      }
      handleClose()
      getStudents()
    } catch (error) {
      console.error(error)
    }
  }

  const handleDeleteStudent = async (id: number) => {
    try {
      const response = await deleteStudentEnrolledClass(id)
      const { success } = response.data
      if (success) {
        message.success(t('Xóa học viên thành công', 'Xóa học viên thành công'))
      }
      getStudents()
    } catch (error) {
      console.error(error)
    }
  }

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      setLoadingContent(true)
      getListStudentCourse({
        keyword: searchValue,
        size: pageSize,
        page: pageNumber,
        enrollClassId: classId
      }).then(res => {
        const { data } = res
        setDataStudents(data.content)
        setLoadingContent(false)
      }).catch(err => console.error(err))
    }
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("")
    }
  };


  const handleOpen = () => {
    setIsOpenDrawer(true)
    setIsEdit(false)
    setIsTitleEdit(false)
  }

  const handleOpenModal = () => {
    setIsOpenedImport(true)
  }

  const handleClose = () => {
    setIsOpenDrawer(false)
    form.resetFields()
  }

  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const handleCloseFilter = () => {
    setShowFilter(false);
  };

  const handleSubmitSearch = () => {
    setLoadingContent(true);
    getListStudentCourse({
      keyword: searchValue,
      size: pageSize,
      page: pageNumber,
      enrollClassId: classId
    }).then(res => {
      const { data } = res
      setDataStudents(data.content)
      setLoadingContent(false)
    }).catch(err => console.error(err))
    if (searchValue === '') {
      setPageNumber(1)
    }
  };

  const clearFilter = (formInstance: FormInstance) => {
    setLoadingContent(true)
    getListStudentCourse({
      keyword: searchValue,
      size: pageSize,
      page: pageNumber,
      enrollClassId: classId
    }).then(res => {
      const { data } = res
      setDataStudents(data.content)
      setLoadingContent(false)
      setFilterData({
        enrolledClassId: classId,
        enrolledDate: enrolledDate,
      });
      formInstance.resetFields()
    }).catch(err => console.error(err))
  };

  const showConfirm = (id: number) => {
    confirm({
      title: (
        <div className="title-container">
          <div style={{ color: "red", fontSize: "20px" }}>
            <DeleteFilled />
          </div>
          <span>{t("Bạn muốn xóa học viên?", "Bạn muốn xóa học viên?")}</span>
        </div>
      ),
      icon: null,
      okText: t("Xác nhận", "Xác nhận"),
      cancelText: t("Hủy", "Hủy"),
      okType: "danger",
      onOk() {
        handleDeleteStudent(id);
      },
      onCancel() {
      },
    });
  };

  const beforeUploadFile = (file: FileType) => {
    const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

    if (!isExcel) {
      message.error(t("Chỉ tải lên được file xlsx/csv", "Chỉ tải lên được file xlsx/csv"));
    }
    setFileList([file])

    return isExcel;
  };

  const propsModal: UploadProps = {
    name: 'file',
    maxCount: 1,
    multiple: false,
    action: BASE_URL_V2 + `/mooc-courses/enrolled-class/import-user/${classId}`,
    headers: { Authorization: 'Bearer ' + accessToken },
    beforeUpload: beforeUploadFile,
    fileList: fileList,
    onChange(info) {
      const { status, response, percent } = info.file;

      if (status !== 'uploading') {
        setCheckUploadFile(true)
      }
      if (status === 'done') {
        message.success(`${t("Tệp", "Tệp")} ${info.file.name} ${t("tải lên thành công.", "tải lên thành công.")}`);
        if (percent) {
          setPercentUpload(percent);
        }

        setCheckUploadFile(false)
      } else if (status === 'error') {
        setCheckUploadFile(true)
        message.error(`${info.file.name} ${t("file tải lên thất bại.", "file tải lên thất bại.")}`);
        if (response.codeStatus === 400) {
          setErrorMessage(response.message)
        }
      }
    },
    onDrop(e) {
    },
    iconRender: (file: UploadFile<any>, listType?: UploadListType | undefined) => {
      const isExcel = file.type === "text/csv" || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel'
      return (
        (<FileExcelOutlined style={{ color: `${isExcel ? '#52C41A' : '#FF4D4F'}` }} />)
      )
    },
    itemRender: (originNode: ReactElement, file: UploadFile, fileList,
      actions: { download: any, preview: any, remove: any }
    ) => {
      const isExcel = file.type === "text/csv" || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel'
      const errorMessages = errorMessage && convertErrors(errorMessage)
      return (
        <>
          {
            <>
              <Flex justify={'space-between'} className="item-render">
                <p className="status-progress--upload">
                  <span>
                    <ExcelFileIcon />
                  </span>
                  <span>
                    {file.name}
                  </span></p>
                <Progress percent={percentUpload}
                  status={checkUploadFile ? 'exception' : 'success'}
                  showInfo={true}
                  size={'default'}
                  style={{ width: 200 }} />
              </Flex>
              {
                !isExcel ? (
                  <div className="errorUpload">
                    <span>{t("Lỗi định dạng file !", "Lỗi định dạng file !")}</span>
                  </div>
                ) : isExcel && errorMessage ? (
                  <div className="errorUpload">
                    <Flex vertical={true} gap={"small"}>
                      <span>{t("Lỗi dữ liệu file!", "Lỗi dữ liệu file!")}</span>
                      {errorMessages && errorMessages.length > 0 ? errorMessages.map((mess: string, index: number) => (
                        <span key={index}>
                          {mess}
                        </span>
                      )) : <span>{errorMessage}</span>}
                    </Flex>
                  </div>
                ) : (
                  <></>
                )
              }
            </>
          }
        </>
      )
    }
  };

  const columns: TableColumnsType = [
    {
      title: 'STT',
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 10
    },
    {
      key: 'studentName',
      title: t('Học viên đăng ký', 'Học viên đăng ký'),
      dataIndex: 'studentName',
      width: 30
    },
    {
      key: 'enrolledDate',
      dataIndex: 'enrolledDate',
      title: t('Ngày ghi danh', 'Ngày ghi danh'),
      render: (_, record: any) => {
        return record.enrolledDate ? formatDateV2(record.enrolledDate) : null;
      },
      width: 40,
    },
    {
      key: 'enrolledUserName',
      dataIndex: 'enrolledUserName',
      title: t('Người ghi danh', 'Người ghi danh'),
      width: 40
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      width: 5,
      render: (_, record: any) => {

        return (
          <>

            <Space>
              <a
                className="action-table"
                onClick={() => showConfirm(record.id)}
              >
                <DeleteOutlined />
              </a>
            </Space>
          </>
        );
      },
      fixed: "right",
    },
  ]

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter
  ) => {
  };

  if (hasError) return (<Page500 />)

  const onFinish = (values: any) => {
    const dataReq = {
      enrollClassID: Number(classId),
      userIds: values.listStudent.map(Number),
      deleteStudentIds: deletedStudents,
    };

    createNewStudentEnrollClass(dataReq);
    setIsOpenDrawer(false);
    form.resetFields();
  }

  const onFinishFilter = (values: any) => {
    setLoadingContent(true)
    setFilterData({
      ...filterData,
      enrolledClassId: get(values, 'enrolledClassId', 0),
      enrolledDateStart: get(values, 'enrolledDate', "").length > 0 ? get(values, 'enrolledDate', "")[0].format('YYYY-MM-DD') : "",
      enrolledDateEnd: get(values, 'enrolledDate', "").length > 0 ? get(values, 'enrolledDate', "")[1].format('YYYY-MM-DD') : "",
    })
    getListStudentCourse({
      enrollClassId: classId,
      enrolledDateStart: filterData.enrolledDateStart,
      enrolledDateEnd: filterData.enrolledDateEnd,
    }).then(res => {
      const { data } = res
      setLoadingContent(false)
      setDataStudents(data.content)
    })
  }
  const handleOK = () => {
    setIsOpenedImport(false)
    getStudents()
  }

  const handleCancel = () => {
    setIsOpenedImport(false)
    setFileList([])

  }

  const downloadSampleTemplate = async (e: MouseEvent) => {
    e.preventDefault()

    try {
      const response = await getSampleTemplateUsersExcel(Number(id),
        Number(classId), {
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'blob' },

      })
      if (response.data) {
        const outputFilename = `sampleTemplate.xlsx`;
        let blobFile = new Blob([response.data], { type: "application/vnd.ms-excel" });
        saveAs(blobFile, outputFilename)
      }
    } catch (err) {
      console.error(err)
    }
  }


  return (
    <>
      <div className="wrapper-settings-history">
        <Form.Provider onFormFinish={(name, { values, forms }) => {
          if (name === 'createStudent') {
            onFinish(values)
          }
        }}>
          <section className="history-page">

            <div className="history-header">
              <Typography.Title className="history-title" style={{ margin: 0 }}>{t("Danh sách học viên ghi danh", "Danh sách học viên ghi danh")}</Typography.Title>
              <FilterTable
                handleOpenFilter={handleOpenFilter}
                showFilter={showFilter}
                searchValue={searchValue}
                handleSearch={handleSearch}
                handleOpen={handleOpen}
                handleOpenModal={handleOpenModal}
                handleChangeInput={handleChangeInput}
                handleSubmitSearch={handleSubmitSearch}
              />
            </div>
            <div className="filter-class--register">
              <FormTable
                handleCloseFilter={handleCloseFilter}
                clearFilter={clearFilter}
                showFilter={showFilter}
                filterData={filterData}
                onFinish={onFinishFilter}
              />
            </div>
            <div className="tabs-heading">
              <TableData
                dataTable={dataStudents}
                dataColumns={columns}
                pageNumber={pageNumber}
                totalRecords={totalRecords}
                pageSize={pageSize}
                setPageSize={setPageSize}
                setPageNumber={setPageNumber}
                pagination={true}
                loadingTable={loadingContent}
                scroll={{ x: 1500, y: 600 }}
                handleTableChangeProps={handleTableChange}
              />
            </div>
          </section>
          <DrawerCustom
            title={t("Thêm học viên", "Thêm học viên")} open={isOpenDrawer} onClose={handleClose}
            extraNode={
              <Space>
                <>
                  <Button onClick={handleClose} className="btn btn-outlined">
                    <CloseOutlined />
                    <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
                  </Button>
                  <Button className="btn btn-primary" disabled={!isDirty} onClick={() => form.submit()}>
                    <SaveOutlined />
                    <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
                  </Button>
                </>
              </Space>
            }
            widthDrawer={730}>
            <CreateStudent 
              formProps={form}
              setIsDirty={setIsDirty}
              isOpenDrawer={isOpenDrawer} 
              dataOptions={dataOptions} 
              classId={Number(classId)}
              listStudents={dataStudents}
              setDeletedStudents={setDeletedStudents}
            />
          </DrawerCustom>
          <ModalUploadFileExcel
            title={t("Import danh sách học viên ghi danh", "Import danh sách học viên ghi danh")}
            open={isOpenedImport}
            isHasStudent={true}
            onOk={handleOK}
            onCancel={handleCancel}
            okText={t("Xác nhận", "Xác nhận")}
            cancelText={t("Huỷ", "Huỷ")}
            propsDragger={propsModal}
            checkError={checkUploadFile}
            downloadSample={downloadSampleTemplate}
          />
        </Form.Provider>
      </div>
    </>
  );
}

export default ListStudentTab;
